import StepOne from "@/components/dashboard/pay/StepOne";

export default function PayStepOne() {
  return <StepOne />;
}
